import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";
import classNames from "classnames";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import { getSortedAccessTypes, GuestlistAccessFilterType, initialAccessFilter } from "./FilterTypes/GuestlistAccessFilterType";
import { getGuestlistListText } from "utilities/enumutils";

interface Props {
  initialLists: server.dto.GuestlistList[]
}

const GuestlistAccessFilter = (props: Props) => {
  const reset = (): GuestlistAccessFilterType => ({
    selectedLists: [],
    initialLists: props.initialLists
  });

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("guestlistAccessTypes", {
    getTitle: () => RESX.Guestlist.List,
    renderSelection: (filter) => {
      return <div className="flex flex-wrap">
        {getSortedAccessTypes(filter).map((at, index) =>
          <React.Fragment key={at.guestlistAccessTypeId}>
            {getGuestlistListText(at)}
            {index !== filter.selectedLists.length - 1 && <span className="padding-right">,</span>}
          </React.Fragment>
        )}
      </div>;
    },
    hasValue: (filter) => {
      return filter.selectedLists.length > 0;
    },
    reset,
    areEqual: (a, b) => {
      return areArrayValuesEqual(a.selectedLists.map(s => s.guestlistAccessTypeId), b.selectedLists.map(s => s.guestlistAccessTypeId));
    }
  });
  useEffect(() => {
    setInitialValue("guestlistAccessTypes", reset());
  }, []);

  const [selectedAccessTypes, setSelectedAccessTypes] = React.useState<server.dto.GuestlistList[]>(initialAccessFilter.selectedLists);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedAccessTypes(getValue("guestlistAccessTypes").selectedLists);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    if (selectedAccessTypes.length > 0) {
      setValue("guestlistAccessTypes", {
        selectedLists: selectedAccessTypes,
        initialLists: props.initialLists ?? []
      });
    } else {
      setValue("guestlistAccessTypes", reset());
    }
    setPopupOpen(false);
  };

  const onToggle = (list: server.dto.GuestlistList) => {
    if (selectedAccessTypes.some(at => at.guestlistAccessTypeId === list.guestlistAccessTypeId)) {
      setSelectedAccessTypes(selectedAccessTypes.filter(at => at.guestlistAccessTypeId !== list.guestlistAccessTypeId));
    } else {
      setSelectedAccessTypes([...selectedAccessTypes, list]);
    }
  };

  const selectedAccessTypeSet = new Set(selectedAccessTypes.map(s => s.guestlistAccessTypeId));

  return <div>
    <FilterPopup
      filterButtonLabel={RESX.Guestlist.List}
      content={<form onSubmit={onApply}>
        <div className={classNames("flex-column gap-small margin-bottom scrollbox-auto")} style={{ maxHeight: 300 }}>
          {props.initialLists.map(accessType => (
            <Checkbox
              key={accessType.guestlistAccessTypeId}
              keyboardNavigationOptions={VerticalKeyboardNavigationGroup("accessType")}
              onChange={() => onToggle(accessType)}
              checked={selectedAccessTypeSet.has(accessType.guestlistAccessTypeId)}
              label={getGuestlistListText(accessType)}
            />
          ))}
        </div>

        <div>
          <Button primary fluid type="submit">{RESX.SelectionManager.Apply}</Button>
        </div>

      </form>}
      width={300}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default GuestlistAccessFilter;
